import { NavigationExtras, Router } from '@angular/router';

/**
 * Awaits Angular `Router.navigate` and returns whether navigation was applied.
 *
 * **UI “busy” flags:** Do not clear a page-level busy/submitting flag in `finally` after a
 * successful API call when you navigate away — `finally` runs as soon as the navigation
 * *promise is created*, not when the transition finishes. Instead:
 * - `await` this helper after the mutation succeeds,
 * - if it returns `false`, clear the busy flag and show an error/toast,
 * - if it returns `true`, keep the page locked until `ionViewDidLeave` / `ionViewWillEnter`
 *   (or until the routed component is destroyed), or clear only after navigation failure.
 */
export function awaitRouterNavigate(
  router: Router,
  commands: Parameters<Router['navigate']>[0],
  extras?: NavigationExtras,
): Promise<boolean> {
  return router.navigate(commands, extras);
}
